'use strict';

export default window.config;



// WEBPACK FOOTER //
// ./src/config.js